import * as Types from '../../../types/schema.generated';

import gql from 'graphql-tag';
export type AccountProfileEditorTableStaffFragment = { __typename?: 'Staff', name?: string | null, profile: { __typename?: 'StaffProfile', avatar?: any | null } };

export const AccountProfileEditorTableStaffFragmentDoc = gql`
    fragment AccountProfileEditorTableStaff on Staff {
  name
  profile {
    avatar
  }
}
    `;